'use client'
import React, { useState, useEffect } from 'react'
import { Search, Plus, Edit3, Trash2, AlertTriangle, Filter, RefreshCw } from 'lucide-react'
import { socket } from '../Containers/MainContainer'

function PlutoSuspectOffers() {
  const [offers, setOffers] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [modalType, setModalType] = useState('add')
  const [selectedOffer, setSelectedOffer] = useState(null)

  const [formData, setFormData] = useState({
    name: '',
    pendingDays: 0,
    condition: 'none',
    conditionReason: '',
    reqHold: 0.4
  })

  useEffect(() => {
    loadOffers()
  }, [])

  const loadOffers = () => {
    setLoading(true)
    socket.on('response_get_admin_bad_offers', (data) => {
      setOffers(data.withdrawals)
      setTotalCount(data.withdrawalsLength)
      setTotalPages(Math.ceil(data.withdrawalsLength / 5))
      setLoading(false)
    })

    socket.emit('getSuspectOffersAdmin', {
      offers_like: searchTerm,
      page: currentPage,
    })
  }

  const handleSearch = (value) => {
    setSearchTerm(value)
    setCurrentPage(1)
    setLoading(true)
    socket.emit('getSuspectOffersAdmin', {
      offers_like: value.toLowerCase(),
      page: 1,
    })
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setLoading(true)
    socket.emit('getSuspectOffersAdmin', {
      offers_like: searchTerm,
      page: page,
    })
  }

  const openModal = (type, offer = null) => {
    setModalType(type)
    setSelectedOffer(offer)

    if (type === 'edit' && offer) {
      setFormData({
        name: offer.name,
        pendingDays: parseInt(offer.pending_time.replace(' days', '')),
        condition: offer.codition || 'none',
        conditionReason: offer.codition_action || '',
        reqHold: offer.req_hold || 0.4
      })
    } else {
      setFormData({
        name: '',
        pendingDays: 0,
        condition: 'none',
        conditionReason: '',
        reqHold: 0.4
      })
    }

    setShowModal(true)
  }

  const handleSubmit = () => {
    if (formData.name.length > 2 && formData.pendingDays >= 0 && formData.reqHold >= 0.01 && formData.reqHold <= 1) {
      if (modalType === 'add') {
        socket.emit('adminAction', {
          action: 'add_pending_offer',
          name: formData.name,
          days: formData.pendingDays,
          condition: formData.condition,
          condition_action: formData.conditionReason,
        })
      } else {
        socket.emit('adminAction', {
          action: 'edit_pending_offer',
          id: selectedOffer.id,
          name: formData.name,
          days: formData.pendingDays,
          req_hold: formData.reqHold,
          condition: formData.condition,
          condition_action: formData.conditionReason,
        })
      }
      setShowModal(false)
      setTimeout(()=>{
        loadOffers()
      },500)
    }
  }

  const handleDelete = () => {
    socket.emit('adminAction', {
      action: 'delete_pending_offer',
      id: selectedOffer.id
    })
    setShowDeleteModal(false)
    setShowModal(false)
    setTimeout(()=>{
      loadOffers()
    },500)
  }

  const getStatusBadge = (active) => {
    return active === 'Yes' ?
      <span style={{
        padding: '4px 10px',
        fontSize: '12px',
        borderRadius: '9999px',
        background: 'rgba(63,185,80,0.15)',
        color: '#3fb950',
        fontWeight: '500',
      }}>Active</span> :
      <span style={{
        padding: '4px 10px',
        fontSize: '12px',
        borderRadius: '9999px',
        background: 'rgba(248,81,73,0.15)',
        color: '#f85149',
        fontWeight: '500',
      }}>Inactive</span>
  }

  const getHoldBadge = (hold) => {
    return hold === 'Yes' ?
      <span style={{
        padding: '4px 10px',
        fontSize: '12px',
        borderRadius: '9999px',
        background: 'rgba(210,153,34,0.15)',
        color: '#d29922',
        fontWeight: '500',
      }}>Hold</span> :
      <span style={{
        padding: '4px 10px',
        fontSize: '12px',
        borderRadius: '9999px',
        background: 'rgba(139,148,158,0.1)',
        color: '#8b949e',
        fontWeight: '500',
      }}>Released</span>
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0d1117', padding: '24px' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '32px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
            <div>
              <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#e6edf3', margin: '0 0 8px 0' }}>Suspect Offers Management</h1>
              <p style={{ color: '#8b949e', margin: 0, fontSize: '14px' }}>Monitor and manage flagged offers and their conditions</p>
            </div>
            <button
              onClick={() => openModal('add')}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: '#238636',
                border: '1px solid #2ea043',
                color: '#ffffff',
                padding: '10px 18px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '500',
                fontSize: '14px',
              }}
            >
              <Plus size={20} />
              Add New Offer
            </button>
          </div>
        </div>

        {/* Stats Card */}
        <div style={{
          background: '#161b22',
          borderRadius: '12px',
          border: '1px solid #21262d',
          borderLeft: '3px solid #f97316',
          padding: '20px 24px',
          marginBottom: '24px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{
              padding: '12px',
              background: 'rgba(249,115,22,0.12)',
              borderRadius: '10px',
            }}>
              <AlertTriangle style={{ color: '#f97316' }} size={24} />
            </div>
            <div>
              <div style={{ fontSize: '26px', fontWeight: '700', color: '#e6edf3' }}>{totalCount.toLocaleString()}</div>
              <div style={{ color: '#8b949e', fontSize: '13px', marginTop: '2px' }}>Total Suspect Offers</div>
            </div>
          </div>
        </div>

        {/* Search */}
        <div style={{
          background: '#161b22',
          borderRadius: '12px',
          border: '1px solid #21262d',
          padding: '20px 24px',
          marginBottom: '24px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ position: 'relative', flex: 1, maxWidth: '400px' }}>
              <Search style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#484f58' }} size={18} />
              <input
                type="text"
                placeholder="Search by offer name..."
                style={{
                  width: '100%',
                  paddingLeft: '40px',
                  paddingRight: '16px',
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  background: '#0d1117',
                  border: '1px solid #30363d',
                  color: '#e6edf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box',
                }}
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                onBlur={(e) => e.target.style.borderColor = '#30363d'}
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div style={{
          background: '#161b22',
          borderRadius: '12px',
          border: '1px solid #21262d',
          overflow: 'hidden',
        }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#161b22', borderBottom: '1px solid #21262d' }}>
                  {['Offer Name', 'Reason', 'Hold Time', 'Status', 'Hold Status', 'Condition', 'Actions'].map((header) => (
                    <th key={header} style={{
                      textAlign: 'left',
                      padding: '14px 20px',
                      fontSize: '11px',
                      fontWeight: '600',
                      color: '#8b949e',
                      textTransform: 'uppercase',
                      letterSpacing: '0.8px',
                      borderBottom: '1px solid #21262d',
                    }}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  [...Array(5)].map((_, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #21262d' }}>
                      {[...Array(7)].map((_, j) => (
                        <td key={j} style={{ padding: '16px 20px' }}>
                          <div style={{
                            height: j === 6 ? '32px' : '16px',
                            width: j === 6 ? '64px' : '100%',
                            background: '#21262d',
                            borderRadius: '6px',
                            animation: 'pulse 2s ease-in-out infinite',
                          }}></div>
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  offers.map((offer) => (
                    <tr key={offer.id} style={{ borderBottom: '1px solid #21262d', transition: 'background 0.15s' }}
                      onMouseEnter={(e) => e.currentTarget.style.background = '#1c2128'}
                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                    >
                      <td style={{ padding: '14px 20px' }}>
                        <div style={{ fontWeight: '500', color: '#e6edf3', fontSize: '13px' }}>{offer.name}</div>
                      </td>
                      <td style={{ padding: '14px 20px' }}>
                        <div style={{ color: '#c9d1d9', maxWidth: '240px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '13px' }} title={offer.reason}>
                          {offer.reason}
                        </div>
                      </td>
                      <td style={{ padding: '14px 20px' }}>
                        <span style={{ color: '#e6edf3', fontWeight: '500', fontSize: '13px' }}>{offer.pending_time}</span>
                      </td>
                      <td style={{ padding: '14px 20px' }}>
                        {getStatusBadge(offer.active)}
                      </td>
                      <td style={{ padding: '14px 20px' }}>
                        {getHoldBadge(offer.hold)}
                      </td>
                      <td style={{ padding: '14px 20px' }}>
                        <div style={{ fontSize: '13px', color: '#c9d1d9' }}>
                          {offer.codition == 'minute' || offer.condition == '1' ? `${offer.codition_action} min` : 'None'}
                        </div>
                      </td>
                      <td style={{ padding: '14px 20px' }}>
                        <button
                          onClick={() => openModal('edit', offer)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '6px 12px',
                            background: 'rgba(88,166,255,0.1)',
                            border: '1px solid rgba(88,166,255,0.3)',
                            color: '#58a6ff',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '500',
                          }}
                        >
                          <Edit3 size={14} />
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        {totalPages > 1 && !loading && (
          <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <button
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
                style={{
                  padding: '8px 14px',
                  color: currentPage === 1 ? '#484f58' : '#c9d1d9',
                  background: '#161b22',
                  border: '1px solid #30363d',
                  borderRadius: '8px',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  opacity: currentPage === 1 ? 0.5 : 1,
                  fontSize: '13px',
                }}
              >
                Previous
              </button>

              {(() => {
                const pages = []
                const showEllipsis = totalPages > 7

                if (!showEllipsis) {
                  for (let i = 1; i <= totalPages; i++) {
                    pages.push(i)
                  }
                } else {
                  if (currentPage <= 4) {
                    for (let i = 1; i <= 5; i++) pages.push(i)
                    if (totalPages > 6) pages.push('...')
                    pages.push(totalPages)
                  } else if (currentPage >= totalPages - 3) {
                    pages.push(1)
                    if (totalPages > 6) pages.push('...')
                    for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i)
                  } else {
                    pages.push(1)
                    pages.push('...')
                    for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i)
                    pages.push('...')
                    pages.push(totalPages)
                  }
                }

                return pages.map((page, index) => {
                  if (page === '...') {
                    return (
                      <span key={`ellipsis-${index}`} style={{ padding: '8px 12px', color: '#484f58', fontSize: '13px' }}>
                        ...
                      </span>
                    )
                  }

                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      style={{
                        padding: '8px 14px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: currentPage === page ? '600' : '400',
                        background: currentPage === page ? '#58a6ff' : '#161b22',
                        color: currentPage === page ? '#ffffff' : '#c9d1d9',
                        border: currentPage === page ? '1px solid #58a6ff' : '1px solid #30363d',
                      }}
                    >
                      {page}
                    </button>
                  )
                })
              })()}

              <button
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
                style={{
                  padding: '8px 14px',
                  color: currentPage === totalPages ? '#484f58' : '#c9d1d9',
                  background: '#161b22',
                  border: '1px solid #30363d',
                  borderRadius: '8px',
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  opacity: currentPage === totalPages ? 0.5 : 1,
                  fontSize: '13px',
                }}
              >
                Next
              </button>
            </div>
          </div>
        )}

        {/* Pagination Info */}
        {!loading && offers.length > 0 && (
          <div style={{ marginTop: '16px', textAlign: 'center', fontSize: '13px', color: '#8b949e' }}>
            Showing {((currentPage - 1) * 5) + 1} to {Math.min(currentPage * 5, totalCount)} of {totalCount} offers
          </div>
        )}
      </div>

      {/* Add/Edit Modal */}
      {showModal && (
        <div style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 50,
          padding: '16px',
        }}>
          <div style={{
            background: '#161b22',
            borderRadius: '12px',
            border: '1px solid #30363d',
            maxWidth: '480px',
            width: '100%',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 16px 48px rgba(0,0,0,0.4)',
          }}>
            <div style={{ padding: '24px' }}>
              <h3 style={{ fontSize: '20px', fontWeight: '700', color: '#e6edf3', marginBottom: '24px', marginTop: 0 }}>
                {modalType === 'add' ? 'Add New Offer' : 'Edit Offer'}
              </h3>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#c9d1d9', marginBottom: '8px' }}>
                    Offer Name
                  </label>
                  <input
                    type="text"
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      background: '#0d1117',
                      border: '1px solid #30363d',
                      color: '#e6edf3',
                      borderRadius: '8px',
                      fontSize: '14px',
                      outline: 'none',
                      boxSizing: 'border-box',
                    }}
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value.toLowerCase()})}
                    placeholder="Enter offer name"
                    onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                    onBlur={(e) => e.target.style.borderColor = '#30363d'}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#c9d1d9', marginBottom: '8px' }}>
                    Pending Days
                  </label>
                  <select
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      background: '#0d1117',
                      border: '1px solid #30363d',
                      color: '#e6edf3',
                      borderRadius: '8px',
                      fontSize: '14px',
                      outline: 'none',
                    }}
                    value={formData.pendingDays}
                    onChange={(e) => setFormData({...formData, pendingDays: parseInt(e.target.value)})}
                  >
                    <option value={0}>0</option>
                    <option value={7}>7</option>
                    <option value={15}>15</option>
                    <option value={30}>30</option>
                    <option value={45}>45</option>
                    <option value={60}>60</option>
                    <option value={90}>90</option>
                  </select>
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#c9d1d9', marginBottom: '8px' }}>
                    Condition Type
                  </label>
                  <select
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      background: '#0d1117',
                      border: '1px solid #30363d',
                      color: '#e6edf3',
                      borderRadius: '8px',
                      fontSize: '14px',
                      outline: 'none',
                    }}
                    value={formData.condition}
                    onChange={(e) => setFormData({...formData, condition: e.target.value})}
                  >
                    <option value={'0'}>None</option>
                    <option value={'1'}>Minutes</option>
                  </select>
                </div>

                {formData.condition == 'minute' || formData.condition == '1' && (
                  <div>
                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#c9d1d9', marginBottom: '8px' }}>
                      Condition Value (Minutes)
                    </label>
                    <input
                      type="text"
                      style={{
                        width: '100%',
                        padding: '10px 12px',
                        background: '#0d1117',
                        border: '1px solid #30363d',
                        color: '#e6edf3',
                        borderRadius: '8px',
                        fontSize: '14px',
                        outline: 'none',
                        boxSizing: 'border-box',
                      }}
                      value={formData.conditionReason}
                      onChange={(e) => setFormData({...formData, conditionReason: e.target.value})}
                      placeholder="Enter minutes"
                      onFocus={(e) => e.target.style.borderColor = '#58a6ff'}
                      onBlur={(e) => e.target.style.borderColor = '#30363d'}
                    />
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '32px' }}>
                <button
                  onClick={handleSubmit}
                  style={{
                    flex: 1,
                    background: '#238636',
                    border: '1px solid #2ea043',
                    color: '#ffffff',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  {modalType === 'add' ? 'Add Offer' : 'Update Offer'}
                </button>

                {modalType === 'edit' && (
                  <button
                    onClick={() => {
                      setShowModal(false)
                      setShowDeleteModal(true)
                    }}
                    style={{
                      padding: '10px 14px',
                      background: 'rgba(248,81,73,0.15)',
                      border: '1px solid #f85149',
                      color: '#f85149',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontWeight: '500',
                    }}
                  >
                    <Trash2 size={16} />
                  </button>
                )}

                <button
                  onClick={() => setShowModal(false)}
                  style={{
                    padding: '10px 16px',
                    border: '1px solid #30363d',
                    background: '#21262d',
                    color: '#c9d1d9',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 50,
          padding: '16px',
        }}>
          <div style={{
            background: '#161b22',
            borderRadius: '12px',
            border: '1px solid #30363d',
            maxWidth: '480px',
            width: '100%',
            boxShadow: '0 16px 48px rgba(0,0,0,0.4)',
          }}>
            <div style={{ padding: '24px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{
                  padding: '10px',
                  background: 'rgba(248,81,73,0.15)',
                  borderRadius: '10px',
                }}>
                  <AlertTriangle style={{ color: '#f85149' }} size={20} />
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#e6edf3', margin: 0 }}>Confirm Deletion</h3>
              </div>

              <p style={{ color: '#c9d1d9', marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                Are you sure you want to delete <strong style={{ color: '#e6edf3' }}>{selectedOffer?.name}#{selectedOffer?.id}</strong>?
                This action cannot be undone.
              </p>

              <div style={{ display: 'flex', gap: '12px' }}>
                <button
                  onClick={handleDelete}
                  style={{
                    flex: 1,
                    background: 'rgba(248,81,73,0.15)',
                    border: '1px solid #f85149',
                    color: '#f85149',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '14px',
                  }}
                >
                  Delete Offer
                </button>
                <button
                  onClick={() => setShowDeleteModal(false)}
                  style={{
                    flex: 1,
                    border: '1px solid #30363d',
                    background: '#21262d',
                    color: '#c9d1d9',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PlutoSuspectOffers
